import { api } from "./api";

const HEX = /^#[0-9a-f]{6}$/i;

export const parseCompanyThemes = (result) => {
  if (result?.status === false) {
    if (/^(?:themes? not found|no themes?(?: found| configured)?)(?: for .+)?[.!]?$/i.test(result.message || result.detail || "")) return [];
    throw new Error(result.message || "Unable to load company theme");
  }
  const data = result?.data !== undefined ? result.data : result;
  const themes = Array.isArray(data) ? data : data?.themes ?? result?.themes;
  const list = themes ?? (data?.theme ? [data] : data === null ? [] : null);
  if (!Array.isArray(list)) throw new Error("Unexpected company theme response");
  const modes = new Set();
  return list.map((item) => {
    if (!["light", "dark"].includes(item.theme) || modes.has(item.theme) ||
        ![item.primary_color, item.gradient_start, item.gradient_end].every(value => HEX.test(value))) {
      throw new Error("Invalid company theme settings returned by the server");
    }
    modes.add(item.theme);
    return {
      theme: item.theme,
      primary_color: item.primary_color,
      gradient_start: item.gradient_start,
      gradient_end: item.gradient_end,
    };
  });
};

export const getCompanyThemes = async (companyId) => {
  try {
    const response = await api.get(`/theme/${companyId}`);
    if (!response.ok) {
      if (response.status === 404) return [];
      throw new Error("Unable to load company theme");
    }
    return parseCompanyThemes(await response.json());
  } catch (error) {
    if (error.status === 404) return [];
    throw error;
  }
};

export const saveCompanyThemes = async (companyId, themes, exists) => {
  const validated = parseCompanyThemes({ themes });
  if (!validated.length || validated.length > 2) throw new Error("Select one or two theme appearances");
  const response = exists
    ? await api.put(`/theme/update/${companyId}`, { themes: validated })
    : await api.post("/theme/add", { company_id: Number(companyId), themes: validated });
  const result = await response.json();
  if (!response.ok || result?.status === false) {
    throw new Error(result?.message || result?.detail || "Unable to save company theme");
  }
  return validated;
};
